var _circle, _path, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceImstruggling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    fill: "#FFA05C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.225 139C128.184 138.835 128.14 138.667 128.092 138.495C127.477 124.888 112.723 114 94.6118 114C76.5007 114 61.7463 124.888 61.1317 138.495C61.0839 138.667 61.0398 138.835 60.9991 139H61.1155C61.1187 138.831 61.1242 138.663 61.1317 138.495C62.9678 131.891 70.1766 120.048 94.6119 120.048C119.047 120.048 126.256 131.891 128.092 138.495C128.099 138.663 128.105 138.831 128.108 139H128.225Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8807,
    cy: 80.8807,
    r: 20.8807,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8645,
    cy: 80.8807,
    r: 17.8977,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.119,
    cy: 80.8807,
    r: 20.8807,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.136,
    cy: 80.2841,
    r: 17.8977,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceImstruggling);
export default __webpack_public_path__ + "static/media/Face_Im struggling.8fe894f1ab08421fb03ebe84c517ee63.svg";
export { ForwardRef as ReactComponent };